import axios from 'axios';
import dayjs from 'dayjs';
import Qs from 'qs';
import { message } from 'ant-design-vue';
import basicStorage from '@/utils/basicStorage';
// TOKEN名称 根据项目变更
export const TOKEN = 'token';
// 默认TOKEN失效时间（分钟），与后端对应
const TOKEN_LOSTTIME = 31;

const service = axios.create({
  // 请求超时时间（ms）
  timeout: 60 * 1000,
  paramsSerializer: {
    serialize: params => {
      return Qs.stringify(params, { allowDots: true });
    }
  }
  // 跨域请求时发送Cookie
  // withCredentials: true
});

// 接口请求
service.interceptors.request.use(
  config => {
    config.headers['Authorization'] = basicStorage.getItem(TOKEN);
    if (!config.params) {
      config.params = { timestamp: new Date().getTime() };
    } else {
      const paramsData = JSON.parse(JSON.stringify(config.params));
      config.params = paramsData;
      config.params.timestamp = new Date().getTime();
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// 接口返回
service.interceptors.response.use(
  response => {
    if (response.headers['authorization']) {
      basicStorage.setItem(TOKEN, response.headers['authorization']);
      const lostTime = dayjs().add(TOKEN_LOSTTIME, 'minute').format('YYYY-MM-DD HH:mm:ss');
      basicStorage.setItem('token-time', lostTime);
    }
    if (response.data.code == '000000') {
      return Promise.resolve(response.data);
    } else if (
      // 需要单独处理数据的接口
      response.config.url == '/api/hr/demand/templateExport' ||
      response.config.fileDownLoadType === 'stream'
    ) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(new Error(response.data.message));
    }
  },
  error => {
    if (error?.response?.headers['authorization']) {
      basicStorage.setItem(TOKEN, error.response.headers['authorization']);
    }
    if (error?.response?.status === 403) {
      message.warning(error.response.data.message, 5);
      return Promise.reject(error.response);
    }
    // const errorTokenCode = ['002002', '002003', '002004', '002005', '002006', '002007'];
    if (error?.response?.data?.code === '103101') {
      message.warning('您的账号在其他设备上登录，如非本人操作，请重新登录', 3);
      failOut();
      // 2007是token超时了，2005是不存在
    } else {
      if (error?.response?.data) {
        if (error?.response?.status === 500) {
          message.warning('服务异常,请稍后再试。(500)', 5);
        } else if (error.response.status === 401) {
          message.warning(error.response.data.message, 5);
          basicStorage.removeItem('token');
          setTimeout(() => {
            failOut();
          }, 1000);
        } else {
          message.warning(error.response.data.message, 5);
        }
      } else {
        message.warning('服务异常,请稍后再试。', 5);
      }
    }
    return Promise.reject(error.response);
  }
);

/**
 * @param url - request 接口地址
 * @param method - request 请求模式：get,post,put,delete
 * @param data - request data or params
 * @param params - true or false  post等类型接口将参数params传输
 */
export const request = async (url, method, data = {}, params) => {
  try {
    const config = {
      url,
      method,
      data
    };
    if (method === 'get' || params) {
      config.params = data;
    }
    const res = await service.request(config);
    return res?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

// 接口返回异常重新登录处理
const failOut = () => {
  basicStorage.removeItem(TOKEN);
  basicStorage.removeItem('token-time');
  setTimeout(() => {
    window.location.reload();
  }, 1000);
};

//接口请求
// service.interceptors.request.use(
//   config => {
//     console.log(config, '=============config');
//     const token = basicStorage.getItem(TOKEN);
//     if (token && config.headers) {
//       // 请求头token信息，请根据实际情况进行修改
//       config.headers[TOKEN] = token;
//     }
//     return config;
//   },
//   error => {
//     Promise.reject(error);
//   }
// );
